import { render, staticRenderFns } from "./BusinessProfileComponent.vue?vue&type=template&id=3d55cc43&scoped=true&"
import script from "./BusinessProfileComponent.vue?vue&type=script&lang=js&"
export * from "./BusinessProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProfileComponent.vue?vue&type=style&index=0&id=3d55cc43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d55cc43",
  null
  
)

export default component.exports